import React from 'react';
import { Fieldset, Select, SelectOption } from '@flixbus/honeycomb-react';
import { useVoucherFormContext } from '../../Context';
import { Asterisk } from '../../Asterisk';
import { Entity } from '../../Context';

const Contract = () => {
  const {
    formState: {
      payload: { entity },
    },
    handleEntityChange,
  } = useVoucherFormContext();

  const handleValueChange = (value: string) => {
    handleEntityChange(value ? (value as Entity) : null);
  };

  return (
    <Fieldset>
      <Select
        id='contract'
        value={entity || ''}
        required
        onChange={e => handleValueChange(e.target.value)}
        label={
          <>
            Contract <Asterisk />
          </>
        }
      >
        <SelectOption value=''>Select Contract</SelectOption>
        <SelectOption value='flix_inc'>Flix Inc</SelectOption>
        <SelectOption value='flix_mexico'>FlixBus Mexico</SelectOption>
      </Select>
    </Fieldset>
  );
};

export default Contract;
